<template>
  <div class="card simple-card p-sm-0">
    <div class="d-md-block card__video-wrapper">
      <a
        :href="processedVideo.url"
        class="card__anchor-wrapper"
        @click="checkForTrustedClick"
      >
        <media-video
          :video="processedVideo"
        />
      </a>
    </div>
    <simple-content :content="processedVideo" />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Model } from '@viddsee/server-api-client';
import { AnalyticPayload } from '@/scripts/libs/analytic/types';
import { UtmParameters } from '@/scripts/types/UtmParameters';
import analytic from '@/scripts/libs/analytic';

import { VideoInfoCardCompat, makeVideoInfoCardCompat } from '@/scripts/models/CardInfoCompat/VideoInfoCardCompat';
import { CardTransformerHandler, transform } from '@/scripts/models/CardInfoCompat/CardTransformer';

import MediaVideo from './Child/MediaVideo.ts.vue';
import SimpleContent from './Child/SimpleContent.ts.vue';
import { TransformerProp } from './Video.declaration';

export default Vue.extend({
  components: {
    MediaVideo,
    SimpleContent,
  },
  props: {
    item: {
      type: Object as PropType<Model.Video.Info>,
      default: null,
    },
    transformer: {
      type: Object as PropType<TransformerProp>,
      default: undefined,
    },
    tracker: {
      type: Object as PropType<AnalyticPayload>,
      default: undefined,
    },
    utmParameters: {
      type: Object as PropType<UtmParameters>,
      default: undefined,
    },
  },
  computed: {
    processedVideo(): VideoInfoCardCompat {
      const videoInfoCardCompat = makeVideoInfoCardCompat(this.item, this.utmParameters);
      return this.transformerHandler(videoInfoCardCompat);
    },

    transformerHandler(): CardTransformerHandler<VideoInfoCardCompat> {
      return transform<VideoInfoCardCompat>(this.transformer);
    },
  },
  methods: {
    checkForTrustedClick(event: Event): void {
      // Occasionally user dragging / scrolling on video card generate untrusted click event
      // This code prevent accidental/fake click from happening
      // Removing this code will cause problem in /profile in touchscreen devices. No other section has this problem
      if (!event.isTrusted) {
        event.preventDefault();
      }

      if (this.tracker) {
        analytic.send(this.tracker);
      }
    },
  },
});
</script>
